import { createMiddleware } from "@tanstack/react-start";
// import { drizzle } from "drizzle-orm/neon-http";
import { drizzle } from "drizzle-orm/neon-serverless";
import * as schema from "../../drizzle/schema";
import * as relations from "../../drizzle/relations";
import { neonConfig } from "@neondatabase/serverless";

declare global {
  var db: ReturnType<typeof createDb> | undefined;
}

export function createDb(databaseUrl: string) {
  // Configure Neon for different environments
  if (process.env.NODE_ENV === "production") {
    neonConfig.webSocketConstructor = WebSocket;
    neonConfig.poolQueryViaFetch = true;
  } else {
    // Local development configuration
    neonConfig.wsProxy = (host) => `${host}:5433/v1`;
    neonConfig.useSecureWebSocket = false;
    neonConfig.pipelineTLS = false;
    neonConfig.pipelineConnect = false;
  }

  // const pool = new Pool({ connectionString: databaseUrl });
  return drizzle(databaseUrl, {
    schema: { ...schema, ...relations },
    // logger: process.env.NODE_ENV !== "production",
    casing: "snake_case",
  });
}

export const configureDb = async () => {
  if (!globalThis.db) {
    // Only configure DB on the server side
    if (typeof process !== "undefined" && process.env) {
      const { serverEnv } = await import("~/lib/server-env");
      globalThis.db = createDb(serverEnv.DATABASE_URL);
    } else {
      throw new Error("Database can only be configured on the server side");
    }
  }
};

export const dbMiddleware = createMiddleware({ type: "function" }).server(
  async ({ next, context: _context }) => {
    try {
      await configureDb();
    } catch (error) {
      console.error("Error configuring DB", error);
    }

    return next();
  },
);
